import React, { useEffect } from "react";
import axios from "axios";

const DropboxChooser = ({ files_send_to_parent, disabled }) => {
  const CLIENT_ID = process.env.DROPBOX_CLIENT_ID; // Make sure to define this in your .env file
  const appKey = CLIENT_ID || "ic6o1zff7ar94a1";

  // Load Dropbox script dynamically
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.dropbox.com/static/api/2/dropins.js";
    script.id = "dropboxjs";
    script.type = "text/javascript";
    script.setAttribute("data-app-key", appKey);
    document.body.appendChild(script);
  }, [appKey]);

  // Open Dropbox Chooser and handle file selection
  const handleDropboxClick = () => {
    if (!window.Dropbox) {
      console.error("Dropbox SDK is not loaded.");
      return;
    }

    window.Dropbox.choose({
      success: async (files) => {
        const processedFiles = await Promise.all(files.map(downloadFile));
        files_send_to_parent(processedFiles, "dropbox");
      },
      cancel: () => {
        console.log("Dropbox Picker cancelled");
      },
      linkType: "direct", // or 'preview' as needed
      multiselect: true, // Adjust as needed
      extensions: [
        // Audio
        ".mp3",
        ".m4a",
        ".mpga",
        ".wav",
        // Video
        ".mp4",
        ".mpeg",
        ".webm",
        // Text & documents
        ".txt",
        ".html",
        ".css",
        ".js",
        ".md",
        ".json",
        ".pdf",
        ".doc",
        ".docx",
        ".pptx",
        ".sh",
        ".ts",
        // Source code
        ".c",
        ".cpp",
        ".cs",
        ".go",
        ".java",
        ".php",
        ".py",
        ".rb",
        ".tex",
      ],
    });
  };

  // Download the file and create a File object
  const downloadFile = async (file) => {
    try {
      const response = await axios.get(file.link, { responseType: "blob" });
      const blob = response.data;
      const fileType = file.link.split(".").pop();
      return new File([blob], file.name, { type: fileType });
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  return (
    <div>
      <button onClick={handleDropboxClick} className="text-[14px]">
        Connect to Dropbox
      </button>
    </div>
  );
};

export default DropboxChooser;
